import React from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WereAlwaysOnline() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll();
  return <section data-section-id="7401" id="lets-get-moving" className="dark bg-background text-foreground relative w-full overflow-hidden border-t-2 border-border">
      <div className="grid lg:grid-cols-2 min-h-[600px] lg:h-[85vh] max-h-[1000px]">
        {}
        <div className="relative flex flex-col justify-center p-8 lg:p-16 xl:p-24 bg-background/95 backdrop-blur-sm z-10">
          {}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
            <div className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
            <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-secondary/10 rounded-full blur-3xl" />
          </div>

          <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-none bg-primary/10 text-primary text-sm font-default font-bold mb-6 border-2 border-primary/20 uppercase tracking-widest">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              Dispatch Active 24/7
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-extrabold tracking-tighter mb-6 text-white uppercase">
              READY TO <span className="text-primary">ROLL.</span>
            </h2>

            <p className="text-lg font-mono text-muted-foreground mb-10 max-w-md leading-relaxed">Legacy Delivery Services provides heavy-duty last mile delivery across DFW and regional semi-truck logistics for the Southeast. Built for bulk, stone, lumber and more.</p>

            <div className="space-y-6 mb-10">
              {}
              <div className="flex items-start gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 rounded-none bg-secondary flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground border-2 border-transparent transition-all duration-300">
                  <Phone className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider mb-1">Direct Dispatch</p>
                  <Link to="tel:+14695904364" className="text-2xl font-default font-bold text-foreground hover:text-primary transition-colors tracking-tight">
                    +1-469-590-4364
                  </Link>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 rounded-none bg-secondary flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground border-2 border-transparent transition-all duration-300">
                  <Mail className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider mb-1">Logistics Support</p>
                  <Link to="mailto:dispatch@transitlink.logistics" className="text-xl font-default font-bold text-foreground hover:text-primary transition-colors tracking-tight">
                    dispatch@transitlink.logistics
                  </Link>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 rounded-none bg-secondary flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground border-2 border-transparent transition-all duration-300">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider mb-1">Regional Hub</p>
                  <p className="text-xl font-default font-bold text-foreground tracking-tight">
                    Dallas/Fort Worth, TX
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button size="lg" className="h-14 px-8 text-base rounded-none font-default font-bold uppercase tracking-widest shadow-none bg-primary text-primary-foreground hover:bg-white hover:text-black transition-all border-2 border-primary" asChild>
                <Link to="https://wa.me/14695904364" newTab>
                  <MessageCircle className="mr-2 w-5 h-5" />
                  Dispatch Now
                </Link>
              </Button>
              <Button variant="outline" size="lg" className="h-14 px-8 text-base rounded-none font-default font-bold uppercase tracking-widest border-2 border-border hover:bg-secondary hover:text-white" asChild>
                <Link to="#">
                  Request Quote <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative w-full h-[500px] lg:h-full bg-secondary/20 overflow-hidden">
          <div ref={mapRef} className={`w-full h-full transition-opacity duration-1000 delay-300 ${mapVisible ? "opacity-100" : "opacity-0"}`}>
            {}
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429158.3846685818!2d-97.1009181!3d32.8205865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c1e7a050f4a8d%3A0x6b4c107f9c216886!2sDallas-Fort%20Worth%20Metroplex%2C%20TX!5e0!3m2!1sen!2sus!4v1715628456789!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            filter: "grayscale(100%) invert(92%) contrast(83%) brightness(0.8)"
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="TransitLink Logistics Service Area" className="w-full h-full" />
            
            {}
            <div className="absolute bottom-8 right-8 hidden lg:block">
              <div className="bg-card/95 backdrop-blur-md border-2 border-border p-6 rounded-none shadow-none max-w-xs">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-primary/20 rounded-none text-primary border border-primary/30">
                    <Clock className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground font-mono font-bold uppercase tracking-widest">Fleet Status</p>
                    <p className="font-default font-extrabold text-foreground uppercase">Operational 24/7</p>
                  </div>
                </div>
                <p className="text-xs font-mono text-muted-foreground pl-[52px]">
                  Serving lumber yards, stone suppliers, and bulk material distributors across TX and the SE region.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}